export function getLocalStorage<T>(namespace: string, key: string, defaultValue: T) {
  const namespacedKey = `${namespace}_${key}`
  const val = localStorage[namespacedKey]
  return val ? JSON.parse(val) : defaultValue
}

export function setLocalStorage<T>(namespace: string, key: string, value: T) {
  const namespacedKey = `${namespace}_${key}`
  localStorage.setItem(namespacedKey, JSON.stringify(value))
}

export function deleteLocalStorage(namespace: string, key: string) {
  const namespacedKey = `${namespace}_${key}`
  localStorage.removeItem(namespacedKey)
}
